import { ILogicalComponentBase } from "../../../Global/Base/Rights/ILogicalComponentBase";
import { RightType } from "../../../Global/Base/Rights/RightTypes";
import { IGenericControl } from "../UI/Controls/ControlInterfaces";
import { ComponentType } from "./ComponentTree";

export interface ILogicalComponent extends ILogicalComponentBase<RightType, IGenericControl, ComponentType> {
    readonly parentControlWrapper: ILogicalComponent;

    /**
     * Zjistí, jestli má smysl vyhodnocovat zadané právo pro obalenou komponentu.
     */
    isEvaluableForRight(rightType: RightType): boolean;
}
